module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.activeJobs), function(job) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "ibox ibox-job-overview"
    }, [_c('div', {
      staticClass: "ibox-title"
    }, [_c('h5', [_c('strong', [_c('span', {
      staticClass: "text-success"
    }, [_vm._v("Active")]), _vm._v(" Job " + _vm._s(job.number))]), _vm._v(" Updated: " + _vm._s(job.updated_at) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "ibox-content ibox-content-padding-xs"
    }, [_c('h2', {
      staticClass: "text-primary"
    }, [_vm._v(_vm._s(job.status_text))]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [(job.progressCompletedPercentage > 0) ? _c('div', {
      staticClass: "progress-bar progress-bar-primary",
      style: ({
        width: ((job.progressCompletedPercentage) + "%")
      }),
      attrs: {
        "aria-valuemax": "100",
        "aria-valuemin": "0",
        "aria-valuenow": job.progressCompletedPercentage,
        "role": "progressbar"
      }
    }, [_c('span', {
      staticClass: "sr-only"
    }, [_vm._v(_vm._s(job.progressCompletedPercentage) + "% Complete")])]) : _vm._e()]), _vm._v(" "), _c('ul', {
      staticClass: "details"
    }, [_c('li', [_c('strong', [_vm._v("Quantity:")]), _vm._v(" " + _vm._s(job.quantity))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Pickup from:")]), _vm._v(" " + _vm._s(job.location_from.formattedName))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Deliver to:")]), _vm._v(" " + _vm._s(job.location_to.formattedName))])])]), _vm._v(" "), _c('div', {
      staticClass: "ibox-footer"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'jobs.show',
          params: {
            id: job.id
          }
        }
      }
    }, [_vm._v("View Job")])], 1)])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-12f08899"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/ActiveJobs.vue
// module id = 932
// module chunks = 0